/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agents_Issue_DescriptionInputs */



/**
* | output |
* | --- |
* | "Pick a name for this relay. You'll see the API key exactly once on the next screen." |
*
* @param {Agents_Issue_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agents_issue_description = /** @type {((inputs?: Agents_Issue_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Issue_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vergeben Sie einen Namen für dieses Relay. Der API-Schlüssel wird auf dem nächsten Bildschirm genau einmal angezeigt.")
	return /** @type {LocalizedString} */ ("Pick a name for this relay. You'll see the API key exactly once on the next screen.")
});